<template>
  <fade-in>
    <div class="header-container">
      <h1>{{ lang[activeLang]['REQUEST LEGAL ASSISTANCE'] }}</h1>
      <p>
        {{ lang[activeLang]['Did you observe ICE activity'] }}
      </p>
      <p>
        <strong>{{ lang[activeLang]['If you have been harassed'] }}</strong>
      </p>
      <p>
        {{ lang[activeLang]['For all other complaints'] }}
        <a href="https://intake.aclu-sdic.org/">https://intake.aclu-sdic.org/</a>.
        {{ lang[activeLang]['This link is also available'] }}
        <a href="https://www.aclu-sdic.org/request-legal-assistance/">https://www.aclu-sdic.org/request-legal-assistance/</a>.
      </p>
      <p>
        {{ lang[activeLang]['Although your response is'] }}
      </p>
      <p>
        {{ lang[activeLang]['Please be aware that all legal claims'] }}
      </p>
      <p>
        {{ lang[activeLang]['Thank you and stay safe'] }}
      </p>
      <p>
        <em>* </em> {{ lang[activeLang]['Indicates the required fields.'] }}
      </p>
    </div>
  </fade-in>
</template>

<script>
import FadeIn from './FadeIn.vue'

export default {
  name: 'FormHomeHeader',
  components: {
    FadeIn
  },
  props: {
    activeLang: {
      type: String,
      default: 'English'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
li {
  text-align: left;
}

a {
  text-decoration: none;
  color: #0055aa;
}
.header-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
}

.spacer {
  width: 2%;
}

.header-logo {
  width: 64px;
  height: 64px;
  color: black;
}

h1 {
  text-align: left;
  font-size: 32px;
}

p {
  text-align: left;
}

em {
  color: rgb(214, 88, 88);
}
</style>
